/**
 * 直播 接口的统一出口
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const liveroom = {
    // 列表
    list(params) {
        return axios.get(api + 'liveRoom/list', {params: params})
    },
    //添加
    create(params) {
        return axios.post(api + 'liveRoom/create', qs.stringify(params))
    },
    //获取编辑信息
    detail(params) {
        return axios.post(api + 'liveRoom/detail', qs.stringify(params))
    },
    //修改
    edit(params) {
        return axios.post(api + 'liveRoom/edit', qs.stringify(params))
    },
    //审核
    check(params) {
        return axios.post(api + 'liveRoom/check', qs.stringify(params))
    },
    //排序
    sort(params) {
        return axios.post(api + 'liveRoom/sort', qs.stringify(params))
    },
    //删除
    remove(params) {
        return axios.post(api + 'liveRoom/remove', qs.stringify(params))
    },
    //回放
    callbacklist(params) {
        return axios.get(api + 'liveRoom/callbacklist', {params: params})
    },
    //审核
    status(params) {
        return axios.post(api + 'liveRoom/callbackstatus', qs.stringify(params))
    },
    //回放评论
    comment(params) {
        return axios.get(api + 'liveRoom/comment', {params: params})
    },
}


// 导出接口
export default liveroom